export const environment = {
    production: true,
    enableHttpErrorDetails: true,
    defaultIdentityServer: '',
    enableSingleSignOn: true,
    mockAuth: true,

    identityServerEndpoint: (server: string | null) => {
        switch (server) {
            default: return environment.newIdentityServerEndpoint;
        }
    },

    webApiServerEndpoint: 'https://wiremockportalapi.quantiumtech.net',

    quantiumCoreHostname: 'https://coreuisalesdemo.quantiumtech.net',

    quantiumSharedHostname: '',

    quantiumEdgeHostname: '',

    client_id: 'quantium-portal-client',
    scope: 'openid offline_access role profile email portalapis portalsso',

    myHostname: 'https://portalsalesdemo.quantiumtech.net', // testing while we are waiting for the DNS propagation

    azureFunctionKeyUrl: 'https://func-app.quantiumportal.com/api/AuthSelectorFuncAlphaBeta?code=QQyh6fNd/ZKKFN8amaaU5NDpbahtXN5DMrOmUUFwDxq188wGHAiiVQ==',

    timeoutSecond: 900, // 15 mins
    idleSecond: 1200,  // 20 mins

    newIdentityServerEndpoint: 'https://accounts.quantiumtech.net',
    azureFunctionEndpoint: 'https://func-app.quantiumportal.com',
    webApiServerEndpointWhiteList: ['https://wiremock-portal-api.azurewebsites.net'],

    fallbackEndpoint(endpoint: string) {
        return '';
    }
};
